export enum PbsCookieNames {
  ECREF_OWNER = 'ecref_owner',
  ECREF = 'ecref',
  /**
   * This cookie is only available when user is logged in and PBS is active (PBS_OWNER should be defined as well)
   */
  PBS_CODE = 'pbs_code',
  /**
   * This cookie will be available even on anonymous user and controls if PBS should be visible
   */
  PBS_OWNER = 'pbs_owner',
  PPL_CODE = 'ppl_code',
}
